import BulkInput from '@components/BulkInput/BulkInput';
import { PopoverContext } from '@context/popover-context';
import { useContext, useEffect, useRef } from 'react';

interface AccreditationsEditPopoverProps {
  field: string[];
  onChange: (values: string[]) => void;
}

type BulkInputHandle = React.ElementRef<typeof BulkInput>;

const AccreditationsEditPopover: React.FC<React.PropsWithChildren<AccreditationsEditPopoverProps>> = ({
  field,
  onChange,
}) => {
  const bulkInputRef = useRef<BulkInputHandle>(null);
  const { show } = useContext(PopoverContext);

  useEffect(() => {
    if (show && bulkInputRef.current?.nodes && bulkInputRef.current?.nodes?.length > 0) {
      const lastInput = bulkInputRef.current.nodes[bulkInputRef.current?.nodes.length - 1];
      const intersectionObserver = new IntersectionObserver((entries, observer) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setTimeout(() => {
            lastInput.focus();
          }, 150);
          observer.unobserve(entry.target);
        }
      });

      intersectionObserver.observe(lastInput);
    }
  }, [show]);

  return (
    <BulkInput
      values={field}
      onChange={onChange}
      placeholders={(index) => `Accreditation #${index + 1}`}
      ref={bulkInputRef}
    />
  );
};

export default AccreditationsEditPopover;
